import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { post, get } from '../utility/fetch';
import { get as getWeb } from '../utility/fetchWeb';
import notification from '../utility/notification';
import logo from "../Assets/images/ConnectHealthPro.png";
import { ArrowBack, CheckCircle, Close as CloseIcon } from '@mui/icons-material';
import { Modal, IconButton } from '@mui/material';
import axios from 'axios';
import { requestNotificationPermission, signInWithGooglePopup, getGoogleRedirectResult } from '../utility/firebase';
import PhoneInput from './inputs/PhoneInput';
import { decryptUserId, isValidReferralCode } from '../utility/encryption';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { GoogleAuthProvider } from 'firebase/auth';

// SVG Icons Component
const StepIcon = ({ step }) => {
    const icons = {
        1: (
            <svg className="w-16 h-16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.43 13.93 13 12 13C10.07 13 8.5 11.43 8.5 9.5C8.5 7.57 10.07 6 12 6ZM12 20C9.97 20 7.57 19.18 5.86 17.12C7.55 15.8 9.68 15 12 15C14.32 15 16.45 15.8 18.14 17.12C16.43 19.18 14.03 20 12 20Z" fill="#5fb257" />
            </svg>
        ),
        2: (
            <svg className="w-16 h-16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#5fb257" />
            </svg>
        ),
        3: (
            <svg className="w-16 h-16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z" fill="#5fb257" />
            </svg>
        )
    };
    return icons[step] || icons[1];
};

// Encouraging messages for each step
const encouragingMessages = {
    1: {
        title: "Welcome! Let's Get Started!",
        subtitle: "Just a few details to create your health profile"
    },
    2: {
        title: "Almost There!",
        subtitle: "We've sent a code to keep your account secure"
    },
    3: {
        title: "Final Step!",
        subtitle: "Create a strong password to protect your health data"
    }
};

// Progress Stepper Component
const ProgressStepper = ({ currentStep }) => {
    const steps = [
        { number: 1, label: 'Account Info' },
        { number: 2, label: 'Verify Email' },
        { number: 3, label: 'Create Password' }
    ];

    const stepIcons = {
        1: (
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.43 13.93 13 12 13C10.07 13 8.5 11.43 8.5 9.5C8.5 7.57 10.07 6 12 6ZM12 20C9.97 20 7.57 19.18 5.86 17.12C7.55 15.8 9.68 15 12 15C14.32 15 16.45 15.8 18.14 17.12C16.43 19.18 14.03 20 12 20Z" fill="currentColor" />
            </svg>
        ),
        2: (
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor" />
            </svg>
        ),
        3: (
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z" fill="currentColor" />
            </svg>
        )
    };

    return (
        <div className="mb-8 px-4">
            <div className="flex items-center justify-between relative">
                {steps.map((step, index) => (
                    <React.Fragment key={step.number}>
                        <div className="flex flex-col items-center relative z-10 flex-1">
                            <div
                                className={`
                                    w-12 h-12 rounded-full flex items-center justify-center
                                    transition-all duration-500 transform
                                    ${step.number < currentStep ? 'bg-green-500 text-white scale-110 shadow-lg' : ''}
                                    ${step.number === currentStep ? 'bg-[#3c7e2d] text-white scale-125 shadow-xl animate-pulse' : ''}
                                    ${step.number > currentStep ? 'bg-gray-200 text-gray-400' : ''}
                                `}
                            >
                                {step.number < currentStep ? (
                                    <CheckCircle className="text-white" style={{ fontSize: '28px' }} />
                                ) : (
                                    stepIcons[step.number]
                                )}
                            </div>
                            <span
                                className={`
                                    text-xs mt-2 font-medium transition-all duration-300
                                    ${step.number <= currentStep ? 'text-[#3c7e2d]' : 'text-gray-400'}
                                `}
                            >
                                {step.label}
                            </span>
                        </div>
                        {index < steps.length - 1 && (
                            <div
                                className={`
                                    flex-1 h-1 mx-2 transition-all duration-500 rounded-full
                                    ${step.number < currentStep ? 'bg-green-500' : 'bg-gray-200'}
                                `}
                                style={{ maxWidth: '120px', marginTop: '-20px' }}
                            />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default function StreamlinedSignup() {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Decrypt the referral code from URL
    const encryptedReferralCode = queryParams.get('userID') || '';

    const [currentStep, setCurrentStep] = useState(1);
    const [referrerInfo, setReferrerInfo] = useState(null);
    const [referralCode, setReferralCode] = useState(encryptedReferralCode);
    const [formData, setFormData] = useState({
        title: '',
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        contact: {
            email: '',
            phone: ''
        },
        emergencyContact: {
            phone: ''
        },
        reffererId: encryptedReferralCode,
        termsAccepted: false
    });
    const [selectedDate, setSelectedDate] = useState(
        encryptedReferralCode && encryptedReferralCode > 0 ? null : null
    );
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tcModalOpen, setTCModalOpen] = useState(false);
    const [tcRead, setTCRead] = useState(false);
    const [pdfBlob, setPdfBlob] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [userType, setUserType] = useState(() => {
        // Get userType from URL query parameter, default to 1 (citizen)
        const urlUserType = parseInt(queryParams.get('userType')) || null;
        return urlUserType;
    }); // 1 for citizen, 2 for practitioner

    // Aggressively preload PDF on component mount
    useEffect(() => {
        const preloadPDF = async () => {
            try {
                // Fetch the PDF as a blob to cache it completely
                const response = await fetch('/Terms-and-Conditions_Consent-Policy_Privacy-Policy.pdf');
                const blob = await response.blob();

                // Create an object URL from the blob
                const url = URL.createObjectURL(blob);

                setPdfBlob(blob);
                setPdfUrl(url);

                console.log('PDF preloaded successfully');
            } catch (error) {
                console.error('Error preloading PDF:', error);
                // Fallback to original URL if preload fails
                setPdfUrl('/Terms-and-Conditions_Consent-Policy_Privacy-Policy.pdf');
            }
        };

        preloadPDF();

        // Cleanup object URL on unmount
        return () => {
            if (pdfUrl && pdfUrl.startsWith('blob:')) {
                URL.revokeObjectURL(pdfUrl);
            }
        };
    }, []);

    // Handle referral code changes
    const handleReferralCodeChange = (e) => {
        const code = e.target.value;
        setReferralCode(code);

        // Try to decrypt the code to get userId
        if (code && code > 0) {
            setFormData(prev => ({
                ...prev,
                reffererId: code
            }));
            // Fetch referrer info when valid code is entered
            fetchReferrerInfo(code);
        } else {
            setFormData(prev => ({
                ...prev,
                reffererId: 0
            }));
            setReferrerInfo(null);
        }
    };

    // Fetch referrer information if referral ID exists
    useEffect(() => {
        if (encryptedReferralCode && encryptedReferralCode > 0) {
            fetchReferrerInfo(encryptedReferralCode);
        }
    }, [encryptedReferralCode]);

    const fetchReferrerInfo = async (id) => {
        try {
            let response;
            if (userType === 2) {
                response = await get(`/employee/employee/${id}`);
            } else {
                response = await getWeb(`/Patient/single/${id}`);
            }

            // Support multiple response shapes: legacy { code: 1, data: {...} }
            // and new { isSuccess: true, data: {...} }
            const ok = response && ((response.code && response.code === 1) || response.isSuccess === true || response.statusCode === 200);
            const data = response?.data || response;

            if (ok && data) {
                const firstName = data.firstName || '';
                const middleName = data.middleName || '';
                const lastName = data.lastName || '';
                const title = data.title || '';

                // Prefer profilePicture (employee) then pictureUrl (patient) then other fallbacks
                const picture = data.profilePicture || data.pictureUrl || data.picture || data.companyLogoUrl || null;

                const displayName = [title, firstName, middleName, lastName].filter(Boolean).join(' ').trim() || data.name || data.fullName || '';

                setReferrerInfo({
                    name: displayName,
                    pictureUrl: picture
                });
            }
        } catch (error) {
            console.error('Failed to fetch referrer info:', error);
        }
    };

    // Function to fetch employee/patient data
    const getEmployeeData = async (userID) => {
        try {
            let response;
            if (userType === 2) {
                response = await get(`/employee/employee/${userID}`);
            } else {
                response = await getWeb(`/Patient/single/${userID}`);
            }

            const ok = response && ((response.code && response.code === 1) || response.isSuccess === true || response.statusCode === 200);
            const data = response?.data || response;

            if (ok && data) {
                // Prefer employee profilePicture, fallback to pictureUrl
                const picture = data.profilePicture || data.pictureUrl || data.picture || data.companyLogoUrl || '';
                sessionStorage.setItem('profilePicture', picture);

                if (data.email) sessionStorage.setItem('email', data.email);
                if (data.title) sessionStorage.setItem('title', data.title);
                if (data.gender) sessionStorage.setItem('gender', data.gender);
                if (data.phoneNumber) sessionStorage.setItem('phoneNumber', data.phoneNumber || data.contact?.phone || '');

                if (data.healthCareProvider) {
                    sessionStorage.setItem('providerName', data.healthCareProvider.name || '');
                    sessionStorage.setItem('providerLocation', data.healthCareProvider.location || '');
                }

                return true;
            }
            return false;
        } catch (error) {
            console.error('Failed to fetch employee data:', error);
            notification({
                type: 'error',
                message: 'Failed to fetch employee data'
            });
            return false;
        }
    };

    // Check for Google redirect result on mount
    useEffect(() => {
        const checkRedirectResult = async () => {
            try {
                const result = await getGoogleRedirectResult();
                if (result?.user) {
                    await handleGoogleSignIn(result);
                }
            } catch (error) {
                console.error('Error checking redirect result:', error);
            }
        };
        checkRedirectResult();
    }, []);

    const handleGoogleSignIn = async (result) => {
        setLoading(true);
        try {
            const user = result.user;
            const firebaseIdToken = await user.getIdToken();
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const googleIdToken = credential.idToken;


            // Send to backend for Google signup/login using axios
            const baseUrl = process.env.REACT_APP_BACKEND_URL;
            const res = await axios.post(`${baseUrl}/Auth/login/social`, {
                provider: 'Google',
                accessToken: googleIdToken,
            });

            console.log("Google signup response:", res.data);

            if (res.data.code === 1) {
                sessionStorage.setItem('token', res.data.data.token);
                sessionStorage.setItem('refreshToken', res.data.data.refreshToken);
                sessionStorage.setItem('name', res.data.data.name);
                sessionStorage.setItem('healthCareProviderId', res.data.data.healthCareProviderId);
                sessionStorage.setItem('role', res.data.data.roles?.[0]?.name ?? '');
                sessionStorage.setItem('userName', res.data.data.userName);
                setUserId(res.data.data.userID);
                sessionStorage.setItem('userId', res.data.data.userID);

                // Store social role privileges
                if (res.data.data.socialRole?.socialRolePrivileges) {
                    sessionStorage.setItem('privileges', JSON.stringify(res.data.data.socialRole.socialRolePrivileges));
                    const privilegeNames = res.data.data.socialRole.socialRolePrivileges
                        .filter(p => p.status === 1)
                        .map(p => p.socialPrivilege.name);
                    sessionStorage.setItem('privilegeNames', JSON.stringify(privilegeNames));
                }

                // Request Firebase device token
                try {
                    const deviceToken = await requestNotificationPermission();
                    if (deviceToken) {
                        await post("/Auth/update-device-token", {
                            userId: res.data.data.userID,
                            deviceToken: deviceToken,
                        });
                        await post(`/UserPresence/connect/${res.data.data.userID}`, {
                            userId: res.data.data.userID,
                        });
                    }
                } catch (error) {
                    console.error("Failed to send device token:", error);
                }

                const employeeDataFetched = await getEmployeeData(res.data.data.userID);

                if (employeeDataFetched) {
                    notification({
                        message: "Login successful",
                        type: "success"
                    });
                    navigate('/landing');
                } else {
                    notification({
                        type: 'error',
                        message: 'Failed to fetch complete profile data'
                    });
                }
            } else {
                notification({
                    message: res.data.message || 'Google signup failed',
                    type: "error"
                });
            }
        } catch (error) {
            console.error('Google signup failed:', error);
            notification({
                type: 'error',
                message: error.response?.data?.message || 'Google signup failed'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSignup = async () => {
        setLoading(true);
        try {
            const result = await signInWithGooglePopup();
            await handleGoogleSignIn(result);
        } catch (error) {
            if (error.code === 'auth/popup-blocked' || error.code === 'auth/popup-closed-by-user') {
                notification({
                    type: 'warning',
                    message: 'Popup was blocked. Please allow popups for this site.'
                });
            } else if (error.code !== 'auth/cancelled-popup-request') {
                notification({
                    type: 'error',
                    message: 'Google Sign-In failed. Please try again.'
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setFormData(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);

        if (date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const formatted = `${day}-${month}-${year}`; // "15-01-2025"
            setFormData(prev => ({
                ...prev,
                dateOfBirth: formatted
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                dateOfBirth: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.title || !formData.firstName || !formData.lastName || !formData.gender ||
            !formData.dateOfBirth || !formData.contact.email || !formData.contact.phone) {
            notification({
                message: "Please fill in all required fields",
                type: "error"
            });
            return;
        }

        // Validate terms acceptance
        if (!formData.termsAccepted) {
            notification({
                message: "Please accept the Terms and Conditions to continue",
                type: "error"
            });
            return;
        }

        setLoading(true);

        try {
            // Create employee profile object with required fields
            const employeeData = {
                roleIds: [{ roleId: 0, roleSpecialistId: 0 }],
                title: formData.title.trim(),
                firstName: formData.firstName.trim().replace(/\s/g, ''),
                middleName: '',
                lastName: formData.lastName.trim().replace(/\s/g, ''),
                email: formData.contact.email.replace(/\s+/g, ''),
                phoneNumber: formData.contact.phone.replace(/\s+/g, ''),
                govtIssuedIDType: 0,
                govtIssuedID: '',
                accountType: 'Private Practitioner',
                healthCareProviderId: 0,
                officeAddress: '',
                gender: formData.gender.trim(),
                dateOfBirth: formData.dateOfBirth,
                placeOfBirth: '',
                stateId: 0,
                lga: 'string',
                city: '',
                nationalityId: 0,
                spokenLanguages: [],
                username: '',
                termsAccepted: formData.termsAccepted,
                refererId: formData.reffererId || 0,
                refererUserType: userType
            };

            // Use fetch directly for /employee/basic-employee-profile
            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            };
            const url = `${process.env.REACT_APP_BACKEND_URL}/employee/basic-employee-profile`;

            const response = await fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(employeeData)
            });

            let res;
            if (response.ok) {
                res = await response.json();
            } else if (response.status === 400) {
                const errorData = await response.json();
                const errorMessages = Object.entries(errorData)
                    .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
                    .join('\n');
                notification({
                    message: errorMessages,
                    type: "error"
                });
                setLoading(false);
                return;
            } else {
                notification({
                    message: "Failed to create profile",
                    type: "error"
                });
                setLoading(false);
                return;
            }
            console.log(res);

            // Store employeeId from registration response
            const newEmployeeId = res?.data?.employeeId;

            notification({
                message: "Profile created—check email for OTP",
                type: "success"
            });

            // Navigate to OTP verification page with email and userId
            navigate('/verify-otp', {
                state: {
                    email: formData.contact.email,
                    userId: newEmployeeId
                }
            });
        } catch (error) {
            console.error('Signup error:', error);
            notification({
                message: "An error occurred during signup",
                type: "error"
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-green-50 to-teal-50 py-8 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
            {/* Animated Background Elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-20 left-10 w-64 h-64 bg-green-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
                <div className="absolute top-40 right-10 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
                <div className="absolute bottom-20 left-1/2 w-64 h-64 bg-teal-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000"></div>
            </div>

            {/* Main Container */}
            <div className="max-w-2xl mx-auto relative">
                {/* Back Button */}
                <button
                    onClick={() => navigate('/login')}
                    className="mb-6 flex items-center gap-2 text-[#3c7e2d] hover:text-[#2d5f22] transition-all duration-300 transform hover:translate-x-[-4px] font-medium"
                >
                    <ArrowBack /> Back to Login
                </button>

                {/* Main Card */}
                <div className="bg-white rounded-3xl shadow-2xl p-8 sm:p-12 backdrop-blur-sm bg-opacity-95 transform transition-all duration-500 ">
                    {/* Logo */}
                    <div className="flex justify-center mb-8 animate-fade-in">
                        <img src={logo} alt="ConnectHealthPro" className="h-16 sm:h-20 transition-transform duration-300 " />
                    </div>

                    {/* Progress Stepper */}
                    <ProgressStepper currentStep={currentStep} />

                    {/* Encouraging Message */}
                    <div className="text-center mb-8 animate-fade-in-up">

                        <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">
                            {encouragingMessages[currentStep].title}
                        </h1>
                        <p className="text-gray-600 text-lg">
                            {encouragingMessages[currentStep].subtitle}
                        </p>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="space-y-5 animate-fade-in-up animation-delay-200">
                        {/* Title Field */}
                        <div className="form-group">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Title <span className="text-red-500">*</span>
                            </label>
                            <select
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300 appearance-none bg-white cursor-pointer"
                                required
                            >
                                <option value="">Select Title</option>
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Miss">Miss</option>
                                <option value="Ms">Ms</option>
                                <option value="Dr">Dr</option>
                                <option value="Prof">Prof</option>
                            </select>
                        </div>

                        {/* First Name & Last Name - Side by Side */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className="form-group">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    First Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300"
                                    required
                                    placeholder="John"
                                />
                            </div>

                            <div className="form-group">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Last Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300"
                                    required
                                    placeholder="Doe"
                                />
                            </div>
                        </div>

                        {/* Gender & Date of Birth - Side by Side */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className="form-group">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Gender <span className="text-red-500">*</span>
                                </label>
                                <select
                                    name="gender"
                                    value={formData.gender}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300 appearance-none bg-white cursor-pointer"
                                    required
                                >
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Date of Birth <span className="text-red-500">*</span>
                                </label>
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={handleDateChange}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    maxDate={new Date()}
                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300"
                                    calendarClassName="border border-gray-200 rounded-xl shadow-xl"
                                    wrapperClassName="w-full"
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="form-group">
                            {/* <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Email (Optional)
                            </label> */}
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Email <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                name="contact.email"
                                value={formData.contact.email}
                                onChange={handleChange}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300"
                                required
                                placeholder="john.doe@example.com"
                            />
                        </div>

                        {/* Phone Number */}
                        <div className="form-group">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Phone Number <span className="text-red-500">*</span>
                            </label>
                            <PhoneInput
                                value={formData.contact.phone}
                                onChange={(phoneValue) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        contact: {
                                            ...prev.contact,
                                            phone: phoneValue
                                        }
                                    }));
                                }}
                                required
                            />
                        </div>

                        {/* Referral Code */}
                        <div className="form-group">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Referral Code (Optional)
                            </label>
                            <input
                                type="text"
                                name="referralCode"
                                value={referralCode}
                                onChange={handleReferralCodeChange}
                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300"
                                placeholder="Enter referral code"
                            />
                            {referralCode && formData.reffererId === 0 && (
                                <p className="text-sm text-amber-600 mt-1">
                                    Invalid referral code
                                </p>
                            )}
                            {referrerInfo && formData.reffererId > 0 && (
                                <p className="text-sm text-green-600 mt-1 flex items-center gap-1">
                                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                    </svg>
                                    Valid referral code - You'll be referred by {referrerInfo.name}
                                </p>
                            )}
                        </div>

                        {/* Terms and Conditions */}
                        <div className="space-y-3">
                            <div>
                                <span
                                    className="text-[#3c7e2d] font-semibold hover:underline cursor-pointer text-base"
                                    onClick={() => setTCModalOpen(true)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    View Terms & Conditions
                                </span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-300">
                                <input
                                    type="checkbox"
                                    id="termsAccepted"
                                    name="termsAccepted"
                                    checked={formData.termsAccepted}
                                    onChange={handleChange}
                                    className="mt-1 w-5 h-5 text-[#3c7e2d] border-2 border-gray-300 rounded focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-50 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                                    required
                                // disabled={!tcRead}
                                />
                                <label htmlFor="termsAccepted" className="text-sm text-gray-700 cursor-pointer">
                                    I have read and accept the Terms & Conditions
                                    <span className="text-red-500"> *</span>
                                </label>
                            </div>
                            {/* {!tcRead && (
                                <div className="text-red-500 text-sm ml-2">
                                    You have to read and accept the Terms & Conditions before proceeding.
                                </div>
                            )} */}
                        </div>

                        {/* Terms & Conditions Modal */}
                        <Modal
                            open={tcModalOpen}
                            onClose={() => setTCModalOpen(false)}
                            aria-labelledby="tc-modal-title"
                            aria-describedby="tc-modal-description"
                            sx={{
                                '& .MuiBackdrop-root': { backgroundColor: 'rgba(0,0,0,0.5)' }
                            }}
                        >
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                background: '#fff',
                                borderRadius: '16px',
                                padding: '24px',
                                maxWidth: '700px',
                                width: '90vw',
                                maxHeight: '90vh',
                                overflow: 'hidden',
                                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <IconButton
                                    onClick={() => setTCModalOpen(false)}
                                    sx={{
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        zIndex: 10,
                                        color: '#333'
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                                <h2 id="tc-modal-title" style={{ marginBottom: '16px', fontSize: '24px', fontWeight: 'bold', color: '#333' }}>
                                    Terms & Conditions
                                </h2>
                                {pdfUrl ? (
                                    <iframe
                                        src={`${pdfUrl}#toolbar=0`}
                                        title="Terms & Conditions"
                                        width="100%"
                                        height="500"
                                        style={{
                                            border: 'none',
                                            borderRadius: '8px',
                                            backgroundColor: '#f8f8f8',
                                            overflow: 'hidden'
                                        }}
                                    />
                                ) : (
                                    <div style={{
                                        height: '500px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: '8px'
                                    }}>
                                        <div style={{ textAlign: 'center' }}>
                                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3c7e2d] mx-auto mb-3"></div>
                                            <p style={{ color: '#666' }}>Loading Terms & Conditions...</p>
                                        </div>
                                    </div>
                                )}
                                <style>
                                    {`
                                    iframe::-webkit-scrollbar { display: none; }
                                    `}
                                </style>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', marginTop: '24px' }}>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setTCModalOpen(false);
                                            setTCRead(true);
                                            setFormData(prev => ({
                                                ...prev,
                                                termsAccepted: true
                                            }));
                                        }}
                                        className="px-6 py-3 bg-[#3c7e2d] text-white font-semibold rounded-lg hover:bg-[#2d5f22] transition-all duration-300 min-w-[100px]"
                                    >
                                        Accept
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setTCModalOpen(false);
                                            setTCRead(false);
                                            setFormData(prev => ({
                                                ...prev,
                                                termsAccepted: false
                                            }));
                                        }}
                                        className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-all duration-300 min-w-[100px]"
                                    >
                                        Decline
                                    </button>
                                </div>
                            </div>
                        </Modal>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={loading}
                            className={`
                                w-full py-4 rounded-xl font-bold text-lg text-white
                                transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg
                                ${loading
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-gradient-to-r from-[#3c7e2d] to-[#2d5f22] hover:from-[#2d5f22] hover:to-[#1e4117] shadow-md'
                                }
                            `}
                        >
                            {loading ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Creating Your Account...
                                </span>
                            ) : (
                                'Create Account'
                            )}
                        </button>
                    </form>

                    {/* Divider */}
                    {/* <div className="relative my-8">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t-2 border-gray-200"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-4 bg-white text-gray-500 font-medium">OR</span>
                        </div>
                    </div> */}

                    {/* Google Sign Up */}
                    {/* <button
                        onClick={handleGoogleSignup}
                        disabled={loading}
                        className="w-full py-4 px-6 border-2 border-gray-300 rounded-xl font-semibold text-gray-700 bg-white hover:bg-gray-50 transition-all duration-300 flex items-center justify-center gap-3 transform hover:scale-[1.02] hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#4285F4" d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z" />
                            <path fill="#34A853" d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z" />
                            <path fill="#FBBC05" d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z" />
                            <path fill="#EA4335" d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z" />
                        </svg>
                        {loading ? 'Signing up...' : 'Sign in with Google'}
                    </button> */}

                    {/* Login Link */}
                    <p className="text-center mt-6 text-gray-600">
                        Already have an account?{' '}
                        <span
                            onClick={() => navigate('/login')}
                            className="text-[#3c7e2d] font-bold hover:underline cursor-pointer transition-all duration-300"
                        >
                            Login
                        </span>
                    </p>
                </div>
            </div>

            {/* Custom Animations */}
            <style jsx>{`
                @keyframes blob {
                    0%, 100% { transform: translate(0, 0) scale(1); }
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                }
                @keyframes fade-in {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes fade-in-up {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slide-down {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes bounce-slow {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }
                .animate-blob {
                    animation: blob 7s infinite;
                }
                .animation-delay-2000 {
                    animation-delay: 2s;
                }
                .animation-delay-4000 {
                    animation-delay: 4s;
                }
                .animate-fade-in {
                    animation: fade-in 0.6s ease-out;
                }
                .animate-fade-in-up {
                    animation: fade-in-up 0.6s ease-out;
                }
                .animation-delay-200 {
                    animation-delay: 0.2s;
                }
                .animate-slide-down {
                    animation: slide-down 0.5s ease-out;
                }
                .animate-bounce-slow {
                    animation: bounce-slow 2s ease-in-out infinite;
                }
            `}</style>
        </div>
    );
}
